import { render, staticRenderFns } from "./ClinicsLiveSearch.vue?vue&type=template&id=5752bcaf&scoped=true&"
import script from "./ClinicsLiveSearch.vue?vue&type=script&lang=js&"
export * from "./ClinicsLiveSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752bcaf",
  null
  
)

export default component.exports